<script>
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';
import FormGroup from '@/components/FormGroup';

export default {
  components: {TrekButton, TrekLink, FormGroup},
};
</script>
